import { render } from "./TheSpotlight.vue?vue&type=template&id=78aee9e6&scoped=true&ts=true"
import script from "./TheSpotlight.vue?vue&type=script&lang=ts"
export * from "./TheSpotlight.vue?vue&type=script&lang=ts"

import "./TheSpotlight.vue?vue&type=style&index=0&id=78aee9e6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78aee9e6"]])

export default __exports__